// // Import required Firebase modules
// import { initializeApp, getApp, getApps } from "firebase/app";
// import { getFirestore } from "firebase/firestore";

// // Firebase configuration object (replace with your project settings)
// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
//   appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
// };

// // Validate Firebase configuration
// const validateFirebaseConfig = (config) => {
//   for (const key in config) {
//     if (!config[key]) {
//       console.error(`Missing Firebase config key: ${key}`);
//       throw new Error(`Firebase configuration is invalid. Missing: ${key}`);
//     }
//   }
// };
// validateFirebaseConfig(firebaseConfig);

// // Singleton Firebase initialization with Firestore
// class Firebase {
//   static instance;
//   constructor() {
//     if (!Firebase.instance) {
//       // Initialize Firebase app (only once)
//       this.app = getApps().length ? getApp() : initializeApp(firebaseConfig);

//       // Initialize Firestore
//       this.db = getFirestore(this.app);

//       Firebase.instance = this;
//     }
//     return Firebase.instance;
//   }

//   // Get Firestore instance
//   getDb() {
//     return this.db;
//   }
// }

// // Export the singleton instance and Firestore reference
// const firebaseInstance = new Firebase();
// export const db = firebaseInstance.getDb();
// export default firebaseInstance;

import { initializeApp, getApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "",
};

const validateFirebaseConfig = (config) => {
  for (const key in config) {
    if (!config[key]) {
      console.error(`Firebase key not found: ${key}`);
      throw new Error(`Firebase key not found: ${key}`);
    }
  }
};

try {
  validateFirebaseConfig(firebaseConfig);
} catch (error) {
  console.error(error.message);
}

class Firebase {
  static instance;
  constructor() {
    if (!Firebase.instance) {
      this.app = getApps().length ? getApp() : initializeApp(firebaseConfig);
      this.db = getFirestore(this.app);
      Firebase.instance = this;
    }
    return Firebase.instance;
  }
  getDb() {
    return this.db;
  }
}

const firebaseInstance = new Firebase();
export const db = firebaseInstance.getDb();
export default firebaseInstance;
